/** User management create/update is paired with Roles → View and Roles → Create (tenant RBAC). */
export const ROLES_VIEW_PERM = "roles:view";
export const ROLES_CREATE_PERM = "roles:create";
export const USERS_MUTATE_PERMS = ["users:create", "users:update"];

/**
 * Find permission-registry domain `id` that lists a given permission key (for accordion expand).
 * @param {unknown[]} domains
 * @param {string} permKey
 * @returns {string|null}
 */
export function permissionDomainIdContainingKey(domains, permKey) {
  if (!Array.isArray(domains) || !permKey) return null;
  for (const d of domains) {
    const keys = d.entries?.length
      ? d.entries.map((e) => e.key).filter(Boolean)
      : Array.isArray(d.permissionKeys)
        ? d.permissionKeys
        : [];
    if (keys.includes(permKey)) return d.id || null;
  }
  return null;
}

/**
 * @param {string[]} prevList
 * @param {string[]} nextList
 * @returns {{ permissions: string[], toastKey: "autoAddedDeps"|"stripped"|null }}
 */
export function reconcileUsersMutateRequiresRolesView(prevList, nextList) {
  const prev = new Set(prevList || []);
  const next = new Set(nextList || []);

  const hasUsersMutate = USERS_MUTATE_PERMS.some((k) => next.has(k));
  const prevHadRolesView = prev.has(ROLES_VIEW_PERM);
  const hasRolesView = next.has(ROLES_VIEW_PERM);

  // Removed Role view while User create/update still on → drop user mutate perms (cannot satisfy deps)
  if (prevHadRolesView && !hasRolesView && hasUsersMutate) {
    for (const k of USERS_MUTATE_PERMS) {
      next.delete(k);
    }
    return { permissions: [...next], toastKey: "stripped" };
  }

  const addedUserMutate = USERS_MUTATE_PERMS.some((k) => next.has(k) && !prev.has(k));

  if (hasUsersMutate) {
    let depsAdded = false;
    if (!next.has(ROLES_VIEW_PERM)) {
      next.add(ROLES_VIEW_PERM);
      depsAdded = true;
    }
    if (!next.has(ROLES_CREATE_PERM)) {
      next.add(ROLES_CREATE_PERM);
      depsAdded = true;
    }
    if (depsAdded && addedUserMutate) {
      return { permissions: [...next], toastKey: "autoAddedDeps" };
    }
  }

  return { permissions: [...next], toastKey: null };
}
